module.exports = __webpack_public_path__ + "img/bitget.c665142a.png";